import React from 'react';
import { ManagedUser } from '../../types';
import styles from './ConfirmBlockModal.module.css';

interface ConfirmBlockModalProps {
  user: ManagedUser;
  loading: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

const ConfirmBlockModal: React.FC<ConfirmBlockModalProps> = ({ user, loading, onConfirm, onClose }) => {
  const action = user.blocked ? 'Unblock' : 'Block';
  const isDangerous = !user.blocked;

  return (
    <div className={styles.modalBackdrop}>
      <div className={`${styles.modalContent} card`}>
        <div className="card-body">
          <h5 className={`card-title ${isDangerous ? 'text-warning' : 'text-success'}`}>
            {action} User
          </h5>
          <p>
            Are you sure you want to {action.toLowerCase()}{' '}
            <strong>{user.name || user.email}</strong>?
          </p>
          {isDangerous && (
            <p className="text-muted small mb-3">
              Blocking this user will immediately prevent them from signing in.
            </p>
          )}
          {!isDangerous && (
            <p className="text-muted small mb-3">
              Unblocking this user will restore their ability to sign in.
            </p>
          )}
          <div className="d-flex justify-content-end gap-2">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button
              type="button"
              className={`btn ${isDangerous ? 'btn-warning' : 'btn-success'}`}
              disabled={loading}
              onClick={onConfirm}
            >
              {loading ? `${action}ing...` : `${action} User`}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmBlockModal;
